import React from "react";
import { useKioskHorizontalStyles } from "./../../../../../kioskstyles";
import { Typography, Grid } from "@mui/material";

function FlexRightPopOutPanel(props) {
  const { show } = props;
  const isNotMobile = props.isNotMobile;
  const colorOverwrite = props.colorOverwrite;
  const kioskstyles = useKioskHorizontalStyles();

  let panelStyle = kioskstyles.flexRightPopOutPanel;
  //let moblePanelStyle = kioskstyles.flexLeftPanelMobile;

  if (colorOverwrite !== undefined) {
    panelStyle = {
      ...kioskstyles.flexLeftPanel,
      backgroundColor: colorOverwrite
      //position: "absolute"
    };
    // moblePanelStyle = {
    //   ...kioskstyles.flexLeftPanelMobile,
    //   backgroundColor: colorOverwrite
    // };
  }

  console.log("[DEBUG] FlexRightPopOutPanel show", show);

  const PanelLeftPosition = show ? "49vw" : "-1vw";
  console.log(
    "[DEBUG] FlexRightPopOutPanel PanelLeftPosition",
    PanelLeftPosition
  );

  return (
    <Grid
      item
      xs={12}
      sm={6}
      style={{
        ...panelStyle,
        left: PanelLeftPosition,
        transition: "left 0.3s ease"
      }}
    >
      <div
        id="rightpopoutpanelcontents"
        style={{
          ...kioskstyles.flexRightPopOutPanelContents
        }}
      >
        <div
          style={{
            ...kioskstyles.flexParentPanel
            //backgroundColor: "blue"
          }}
        >
          {props.children}
        </div>
      </div>
    </Grid>
  );

  // if (isNotMobile) {
  //   return (
  //     <Grid item xs={12} sm={6} style={panelStyle}>
  //       {props.children}
  //     </Grid>
  //   );
  // } else {
  //   return (
  //     <Grid item xs={12} sm={6} style={moblePanelStyle}>
  //       {props.children}
  //     </Grid>
  //   );
  // }
}

export default FlexRightPopOutPanel;
